import React, {useRef} from "react";
import styled from "styled-components";
import Icon from "@/components/common/Icon/Icon";
import {ICONS} from "@/constants";
import {useRouter} from "next/router";
import {getCssSizeValue} from "@/utils/utils";
import {BREAKPOINTS} from "@/styles/themeSettings";

const DateInputWrapper = styled.div`
	position: relative;
	display: flex;
	justify-content: space-between;
	align-items: center;
	border: 1px solid ${({ theme }) => theme.colors.richBlack};
	border-radius: 6px;
	cursor: pointer;
	flex: 1;
	
	gap: ${getCssSizeValue(12, BREAKPOINTS.MOBILE)};
	
    padding: ${getCssSizeValue(12, BREAKPOINTS.MOBILE)} ${getCssSizeValue(6, BREAKPOINTS.MOBILE)} ${getCssSizeValue(12, BREAKPOINTS.MOBILE)} ${getCssSizeValue(12, BREAKPOINTS.MOBILE)};
	
    @media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
        justify-content: flex-start;
        gap: ${getCssSizeValue(12, BREAKPOINTS.TABLET)};
        padding: ${getCssSizeValue(14, BREAKPOINTS.TABLET)} ${getCssSizeValue(16, BREAKPOINTS.TABLET)} ${getCssSizeValue(14, BREAKPOINTS.TABLET)} ${getCssSizeValue(17, BREAKPOINTS.TABLET)};
		flex: initial;
	}

    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
        gap: ${getCssSizeValue(12)};
        padding: ${getCssSizeValue(14)} ${getCssSizeValue(20)} ${getCssSizeValue(14)} ${getCssSizeValue(17)};
    }
	
	.icon {
        width: ${getCssSizeValue(18, BREAKPOINTS.MOBILE)};
        height: ${getCssSizeValue(20, BREAKPOINTS.MOBILE)};
		
		svg {
            @media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
                width: ${getCssSizeValue(18, BREAKPOINTS.TABLET)};
                height: ${getCssSizeValue(20, BREAKPOINTS.TABLET)};
			}
            @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
                width: ${getCssSizeValue(18)};
                height: ${getCssSizeValue(20)};
			}
		}
	}
`;

const HiddenDateInput = styled.input`
	pointer-events: none;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 0;
	opacity: 0;
	height: 100%;
	width: 100%;
`;

function convertDateToLocaleFormat(value, locale) {
	if (!value) return null

	let dateString = new Date(value).toLocaleDateString(locale, {
		day: "2-digit",
		month: "2-digit",
		year: "2-digit"
	});
	return dateString.replace(/\//g, '.');
}

export default function CustomDateInput({
	value,
	onChange
}) {
	const router = useRouter()
	const dateInputRef = useRef(null);
	const formattedDate = convertDateToLocaleFormat(value, router.locale)

	const handleTriggerInput = () => {
		if (dateInputRef.current) {
			dateInputRef.current.showPicker();
		}
	};

	return (
		<DateInputWrapper
			onClick={handleTriggerInput}
			className="typo-strawford typo-strawford-35"
		>
			{formattedDate || 'dd.mm.rr'}
			<Icon name={ICONS.CALENDAR} color='richBlack' />
			<HiddenDateInput
				ref={dateInputRef}
				type="date"
				value={value}
				onChange={onChange}
			/>
		</DateInputWrapper>
	)
}